import { Provider } from "react-redux";
import { store, persistor } from "@redux";
import { PersistGate } from "redux-persist/integration/react";
import { ModuleMain } from "@modules";
import "@translations/i18n";
import { ConfigProvider, Modal, notification } from "antd";
import { theme } from "./Utils/theme";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./Components/styles";
import { ModalContext, NotiContext } from "./Utils/hooks";

function App() {
  const [api, contextHolder] = notification.useNotification();
  const [modal, contextModalHolder] = Modal.useModal();

  return (
    <ConfigProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        {/* global apply modal with theme token */}
        <ModalContext.Provider value={modal}>
          {contextModalHolder}
          {/* global apply noti msg and applied theme */}
          <NotiContext.Provider value={api}>
            {contextHolder}
            <Provider store={store}>
              <PersistGate loading={null} persistor={persistor}>
                <ModuleMain />
              </PersistGate>
            </Provider>
          </NotiContext.Provider>
        </ModalContext.Provider>
      </ThemeProvider>
    </ConfigProvider>
  );
}

export default App;
